import React from "react";
import { FaSolarPanel, FaRobot } from "react-icons/fa";
import { IoHardwareChipOutline } from "react-icons/io5";
import { CgWebsite } from "react-icons/cg";
import { BiMobileAlt, BiDollarCircle } from "react-icons/bi";

const ServiceCard = ({ icon: Icon, title, description }) => (
  <div
    className="group bg-neutral-light rounded-xl p-6 md:p-8 hover:bg-white
                hover:shadow-card-hover transition-all duration-300"
  >
    <div className="flex items-center gap-4 mb-4">
      <div
        className="w-12 h-12 md:w-14 md:h-14 bg-primary-100 rounded-xl flex items-center justify-center
                    flex-shrink-0 group-hover:bg-primary-500 transition-colors duration-300"
      >
        <Icon
          className="text-2xl md:text-3xl text-primary-500 group-hover:text-white
                     transition-colors duration-300"
        />
      </div>
      <h4 className="text-lg md:text-xl font-semibold text-neutral-dark">{title}</h4>
    </div>
    <p className="text-sm md:text-base text-neutral leading-relaxed">{description}</p>
  </div>
);

const Services = () => {
  const divisions = [
    {
      title: "Division of Electronic Innovations",
      subtitle: "Team Led by Engineer Samir Rizk",
      services: [
        {
          icon: FaSolarPanel,
          title: "Solar Energy",
          description:
            "We have an experienced team in installing solar energy systems. Partnered with Marvel Tech agent in Lebanon, we have accomplished over 40 solar projects.",
        },
        {
          icon: IoHardwareChipOutline,
          title: "Electronic Inventions",
          description:
            "Our department for electronic innovations has wide experience in electric wiring, micro-controllers, and automation solutions besides solar systems.",
        },
        {
          icon: FaRobot,
          title: "Electric Solutions",
          description:
            "We provide support for businesses or individuals seeking to optimize their technology and help users select the most suitable hardware components.",
        },
      ],
    },
    {
      title: "Division of Software Solutions",
      subtitle: "Team Led by Engineer Yasser Haidar",
      services: [
        {
          icon: CgWebsite,
          title: "Web Development",
          description:
            "Dedicated teams for full stack web development, UI/UX design, and cloud solutions and hosting. We build modern, scalable web applications.",
        },
        {
          icon: BiMobileAlt,
          title: "Mobile Development",
          description:
            "Cross-platform mobile applications via React Native and Flutter framework for Android and iOS. One codebase, multiple platforms.",
        },
        {
          icon: BiDollarCircle,
          title: "ERP Systems",
          description:
            "Finance, HR, supply chain, and customer relations solutions. HexaPi Tech empowers businesses to streamline operations and drive growth.",
        },
      ],
    },
  ];

  return (
    <section id="service" className="py-10 lg:py-14 bg-white">
      <div className="max-w-6xl mx-auto px-4 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="section-subheading">What We Do</span>
          <h2 className="section-heading">Our Divisions</h2>
          <div className="w-20 h-1 bg-primary-500 mx-auto mt-4 rounded-full"></div>
        </div>

        {/* Divisions */}
        {divisions.map((division, divIndex) => (
          <div key={divIndex} className={divIndex > 0 ? "mt-16" : ""}>
            {/* Division Header */}
            <div className="text-center mb-10">
              <h3 className="text-2xl font-semibold text-neutral-dark mb-2">
                {division.title}
              </h3>
              {division.subtitle && (
                <p className="text-neutral">{division.subtitle}</p>
              )}
            </div>

            {/* Services Grid */}
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {division.services.map((service, serviceIndex) => (
                <ServiceCard key={serviceIndex} {...service} />
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Services;
